import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddFacilitiesSafety.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="12.1"
          title="Procedure and/or Process for Laboratory Safety"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Ensure all safety measures are implemented at the laboratory as applicable to national and/or international guidelines and regulations.",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.2"
          title="Facilities and Environmental Conditions (including POCT)"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Define how to evaluate and determine the sufficiency and adequacy of the space allocated for the performance of the scope of work;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Ensure storage and disposal facilities meet applicable requirements;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Ensure personnel have space for personal activities (supply of drinking water, storage space for personal and protective equipment and clothing);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Monitor, control and record any specific environmental and facility requirements",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Sample collection facilities, taking into consideration patient privacy, comfort, and needs (e.g., disabled access, toilet facility) of patients and accommodation of accompanying persons (e.g., guardian or interpreter) during collection;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Implementation, recording, monitoring, and reviewing of facility controls (access, safety, etc.).",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.3"
          title="Adequacy of Size and Layout of Laboratory"
          questions={[
            {
              content:
                "Is there documented evidence that the laboratory has evaluated the adequacy of the size and layout of the laboratory and organized the space so that workstations are positioned to reduce risk, ensure optimal workflow, and prioritize occupational health?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.4"
          title="Patient Care Areas"
          questions={[
            {
              content:
                "Are patient care and testing areas of the laboratory distinctly separate from one another?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.5"
          title="Housekeeping"
          questions={[
            {
              content:
                "Are housekeeping activities performed to ensure the efficient operations of the laboratory and the safety of the personnel, users, and patients?",
              hideOptions: true,
            },
            {
              content:
                "Are there records of housekeeping duties performed daily (at the minimum)?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are all necessary housekeeping supplies present and easily accessible?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are all equipment and work surfaces (that are used for processing contaminated materials) cleaned and disinfected with appropriate agents both before and at the end of each working shift and whenever spills or other contamination has occurred?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.6"
          title="Physical Work Environment"
          questions={[
            {
              content:
                "Is the physical work environment appropriate for testing?",
              hideOptions: true,
            },
            {
              content: (
                <>
                  Free of clutter?
                  <br />
                  ISO 15190: 2020 Clause 18 j
                </>
              ),
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Adequately ventilated?
                  <br />
                  ISO 15190: 2020 Clause 9.2
                </>
              ),
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Climate-controlled for optimum equipment function?
                  <br />
                  ISO 15189:2022 Clause: 6.3.1
                </>
              ),
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are filters checked, cleaned and/or replaced at regular intervals, where air-conditioning is installed?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are wires and cables properly installed and protected from hazardous factors and from traffic?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is there a functioning back-up power supply (generator) and are there records of maintenance?",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is critical equipment supported by uninterrupted power source systems?",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is all equipment placed appropriately (away from water hazards, out of traffic areas)?",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are appropriate provisions made for adequate water supply, including deionized water or distilled water, if needed?",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Is clerical work performed in a designated clean area?",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is safety signage posted and enforced, including “NO EATING, SMOKING, OR DRINKING”?",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.7"
          title="Laboratory Access"
          questions={[
            {
              content: (
                <>
                  Is the laboratory properly secured from unauthorized access
                  with appropriate systems and signage?
                  <br />
                  Note: Access control should take into consideration safety,
                  confidentiality and quality and safeguard medical information
                  and patient samples
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.8"
          title="Laboratory Storage Areas"
          questions={[
            {
              content:
                "Is there adequate storage space under the appropriate conditions and properly labelled for the following?",
              hideOptions: true,
            },
            {
              content: "Samples;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Equipment;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Reagents and consumables;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Documents and records;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Patient samples and materials used in examination processes (stored separately);",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Hazardous materials and biological waste appropriate to the classification in context of any statutory or regulatory requirements;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Personnel items, food, and drinks.",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.9"
          title="Laboratory Facilities"
          questions={[
            {
              content:
                "Note: The work area should be cleaned regularly. An appropriate disinfectant should be used. At a minimum, all bench tops and working surfaces should be disinfected at the beginning and end of every shift. All spills should be contained immediately and decontaminated, as appropriate, and the work surfaces disinfected",
              hideOptions: true,
            },
            {
              content:
                "Are laboratory facilities maintained in a functional and reliable condition (e.g., housekeeping and maintenance, etc.)?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does the laboratory have adequate safety facilities and devices, where applicable, and regularly verify their proper functioning (eye wash stations, emergency showers, fire alarms, etc.)?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is the work area clean and free of leakage and spills, and are disinfection and decontamination procedures conducted and documented, where appropriate?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.10"
          title="Safety Cabinet (biosafety cabinet, laboratory hood, etc.)"
          questions={[
            {
              content: (
                <>
                  Where a biosafety cabinet is present and required to perform
                  work, are the following conditions met, where appropriate?
                  <br />
                  Note: A biosafety cabinet should be used to prevent aerosol
                  exposure to contagious samples or organisms. For proper
                  functioning and full protection, biosafety cabinets require
                  periodic maintenance and should be serviced accordingly.
                  Biosafety cabinets should be recertified according to national
                  protocols or manufacturer requirements
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Selection, location, design, and type of biological safety cabinet utilized appropriate to the level of risk containment required for safe working;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Used in such a manner as to avoid compromising the cabinet’s function (e.g., jarring or mishandling delicate HEPA filters);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Vented appropriate to the microbiological risk and consistent with safety requirements; frequently monitored to ensure that they function as designed;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Tested/certified upon installation, when moved or repaired and annually; records shall be kept of the inspection and any functionality testing result;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Proof of inspection indicated by a certification label displayed on the cabinet",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.11 "
          title="Safety Program"
          questions={[
            {
              content:
                "Does the laboratory have a safety program that includes, but is not limited to, the following elements?",
              hideOptions: true,
            },
            {
              content: "Safety and health policy;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Written work procedures that include safe work practices;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Education and training of laboratory-associated personnel;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Supervision of personnel;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Regular inspections;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Hazardous materials and substances;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Health surveillance and prophylaxis;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "First aid services and equipment;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Investigation of accidents and illnesses;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Records and statistics;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Requirement for follow-up to ensure that all required actions arising from the audit are completed;",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Fire safety;",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Oversight of good housekeeping practices.",
              number: "m",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.12 "
          title="Laboratory Safety Manual"
          questions={[
            {
              content: (
                <>
                  Is a laboratory safety manual available, accessible, and up to
                  date?
                  <br />
                  Does the safety manual include guidelines on the following
                  topics?
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Safety policy;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Blood and body fluid precautions;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Biosafety and biosecurity hazards, where appropriate;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Risk assessment and mitigation;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Biological hazards;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Hazardous waste disposal;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Chemical safety;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Radiation;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Vaccination;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Post-exposure prophylaxis",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Fire prevention;",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Electrical safety",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.13"
          title="Waste Disposal"
          questions={[
            {
              content: (
                <>
                  Note 1: Waste should be separated according to biohazard risk,
                  with infectious and non-infectious waste disposed of in
                  separate containers. Infectious waste should be discarded into
                  containers that do not leak and are clearly marked with a
                  biohazard symbol. Sharp instruments and needles should be
                  discarded in puncture resistant containers. Both infectious
                  waste and sharps containers should be autoclaved before being
                  discarded to prevent injury from exposed waste; infectious
                  waste should be incinerated, burnt in a pit, or buried.
                  <br />
                  Note 2: All syringes, needles, lancets, or other bloodletting
                  devices capable of transmitting infection must be used only
                  once and discarded in puncture resistant containers that are
                  not overfilled. Sharps containers should be clearly marked to
                  warn handlers of the potential hazard and should be available
                  in areas where sharps are commonly used.
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Is sufficient waste disposal available and adequate?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is waste separated into infectious and non-infectious waste, with infectious waste autoclaved/incinerated?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are ‘sharps’ handled and disposed of properly in ‘sharps’ containers that are appropriately utilized?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are adequate records of hazardous waste disposal retained in an accessible file by the laboratory?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.14"
          title="Hazardous Chemicals"
          questions={[
            {
              content: (
                <>
                  Are hazardous chemicals/materials properly handled?
                  <br />
                  Note: Chemicals present a broad range of physical (e.g.,
                  flammable, corrosive) and biological (e.g., toxic,
                  radioactive, carcinogenic) hazards
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Are hazardous chemicals properly classified and labelled?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are chemicals segregated and stored by reactivity class and flammability?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Are hazardous chemicals properly utilized according to safety
                  data sheets (SDS)?
                  <br />
                  Note: The SDS may be available in a computerized format as
                  long personnel are trained on how to access them, the
                  computers are kept in working order and the employer can
                  provide a hard copy of the SDS on request"
                </>
              ),
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are hazardous chemicals properly disposed of according to national and/or international guidelines or SDS?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is there documented information and records of communication with laboratory personnel regarding the potential routes of entry for toxic chemicals and how best to perform the necessary precautions to prevent exposure?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are oxidizing materials used with appropriate precautions?",
              number: "1",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are corrosive materials used with appropriate precautions?",
              number: "2",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Are suitable chemical spill measures provided, including
                  neutralizing agents, spill containment, and absorbents
                  appropriate for the chemicals used
                  <br />
                  Note: All hazardous chemicals must be labelled with the
                  chemical’s name and with hazard markings. Flammable chemicals
                  must be stored out of sunlight and below their flashpoint,
                  preferably in a steel cabinet in a wellventilated area.
                  Flammable and corrosive agents should be separated from one
                  another. Distinct care should always be taken when handling
                  hazardous chemicals
                </>
              ),
              number: "3",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.15"
          title="Fire Safety"
          questions={[
            {
              content:
                "Are all electrical cords, plugs, and receptacles used appropriately, installed, and in good condition?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is an appropriate fire extinguisher available, properly placed, in working condition, and routinely inspected?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are there automatic smoke-detection, heat-detection, and alarm systems adequately placed within the laboratory?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is there a training program in fire safety including fire drills and use of fire extinguishers, which is given to all laboratory workers and personnel who share the building?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.16"
          title="Safety Audits"
          questions={[
            {
              content: (
                <>
                  Are safety inspections or audits conducted regularly and
                  documented?
                  <br />
                  Note: Work sites shall be surveyed/inspected at least annually
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Is there a safety audit plan or schedule that ensures all activities of the laboratory are checked for safety compliance?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are safety inspections or safety audits being carried out by authorized personnel?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are the personnel conducting the internal audits trained in safety?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is root cause analysis and corrective action taken for safety inspection findings?",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are safety inspection findings documented and presented to the laboratory management and relevant personnel for review?",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.17"
          title="Safety Equipment"
          questions={[
            {
              content: (
                <>
                  Is standard safety equipment available and properly used
                  within the laboratory?
                  <br />
                  Note: Management is responsible for providing appropriate
                  personal protective equipment (gloves, lab coats, eye
                  protection, etc.) in useable condition. Laboratory personnel
                  must always utilize personal protective equipment while in the
                  laboratory. Protective clothing should not be worn outside
                  designated working areas
                </>
              ),
              hideOptions: true,
            },
            {
              content: (
                <>
                  Safety cabinet(s) (including biosafety cabinets, laboratory
                  hoods, etc.);
                  <br />
                  ISO 15190:2020 Clause 7.7
                </>
              ),
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Covers, safety caps, safety buckets on centrifuge(s);",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Hand-washing station;
                  <br />
                  ISO 15190: 2020 Clause 4.2
                </>
              ),
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Eyewash station/bottle(s) and emergency showers where
                  applicable;
                  <br />
                  ISO 15190: 2020 Clause 10.3
                </>
              ),
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Spill kit(s);
                  <br />
                  ISO 15190: 2020 Clause 10.5
                </>
              ),
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  f. First aid kit(s).
                  <br />
                  ISO 15190: 2020 Clause 10.2
                </>
              ),
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="12.18"
          title="Personnel Protective Equipment"
          questions={[
            {
              content:
                "Is personal protective equipment easily accessible at the workstation and utilized appropriately and consistently?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.19"
          title="Personnel Vaccinations"
          questions={[
            {
              content: (
                <>
                  Are post-exposure prophylaxis policies and procedures readily
                  available to laboratory personnel and implemented after
                  possible and known exposures?
                  <br />
                  Note 1: The laboratory must have a procedure for follow-up of
                  possible and known percutaneous, mucus membrane or abraded
                  skin exposure to HIV, hepatitis B virus, hepatitis C virus,
                  tuberculosis bacteria, and other applicable pathogens. The
                  procedure should include clinical and serological evaluation
                  and appropriate prophylaxis
                  <br />
                  Note 2: Laboratory personnel should be offered appropriate
                  vaccinations—particularly for hepatitis B virus. Personnel may
                  decline to receive the vaccination. In that situation,
                  personnel must sign a declination form which must be filed in
                  their respective personnel file
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.20"
          title="Post-Exposure Prophylaxis"
          questions={[
            {
              content: (
                <>
                  Are adverse incidents, accidents, or injuries (from equipment,
                  reagents, consumables, occupational injuries, medical
                  screening, or illnesses, etc.) fully investigated, documented,
                  and subsequent steps taken to reduce the possibility of
                  recurrence?
                  <br />
                  Note: The laboratory must have a procedure for follow-up of
                  possible and known percutaneous, mucus membrane or abraded
                  skin exposure to HIV, hepatitis B virus, or hepatitis C virus.
                  The procedure should include clinical and serological
                  evaluation and appropriate prophylaxis
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.21"
          title="Management of Adverse Incidents or Injury"
          questions={[
            {
              content: (
                <>
                  Are adverse incidents or injuries from equipment, reagents,
                  occupational injuries, medical screening, or illnesses,
                  documented and investigated?
                  <br />
                  Note: All occupational injuries or illnesses should be
                  thoroughly investigated and documented in the safety log or
                  occurrence log, depending on the laboratory. Corrective
                  actions taken by the laboratory in response to an accident or
                  injury must also be documented.
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.22"
          title="Safety Training"
          questions={[
            {
              content: (
                <>
                  Are all personnel (including drivers / couriers, phlebotomists
                  and cleaners) performing laboratory activities trained in
                  safety practices relevant to their job tasks (including
                  general safety, biosafety, and biosecurity, where
                  appropriate)?
                  <br />
                  Note: All personnel must be trained in prevention or control
                  of the effects of adverse incidents.
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.23"
          title="Laboratory Safety Officer"
          questions={[
            {
              content: (
                <>
                  Is a trained safety officer designated to implement and
                  monitor the safety program in the laboratory?
                  <br />
                  Note: A safety officer should be appointed to implement and
                  monitor the safety program, coordinate safety training, and
                  handle all safety issues. This officer should receive safety
                  training
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="12.24"
          title="Biosecurity"
          questions={[
            {
              content:
                "Are biosecurity policies, processes, and procedures implemented by the laboratory, where appropriate?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddFacilitiesSafety = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      if (!questionnaireId) return; // new form
      try {
        setLoading(true);
        const response = await fetch(
          `${env.kataApiUrl}/api/certification/id/${questionnaireId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load questionnaire");
        }

        const data = await response.json();

        console.log("DATATAA", data);

        setStatus(data.status);

        const prefilled = {};
        if (data.answers && Array.isArray(data.answers)) {
          data.answers.forEach((ans) => {
            prefilled[ans.questionNumber] = {
              score: ans.score,
              comment: ans.comment,
              points: ans.points,
            };
          });
        }

        setAnswers(prefilled);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId, token]);

  const handleAnswerChange = (questionNumber, score, comment, points) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionNumber]: {
        score,
        comment,
        points: points ? Number(points) : undefined,
      },
    }));
  };

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  const submitAssessment = async () => {
    const answersArray = Object.entries(answers).map(
      ([questionNumber, data]) => ({
        questionNumber,
        score: data.score,
        comment: data.comment,
        points: data.points,
      })
    );

    const payload = {
      name: "SLIPTA",
      labId,
      section: "Facilities & Safety",
      auditorId: user.id,
      answers: answersArray,
    };

    const url = questionnaireId
      ? `${env.kataApiUrl}/api/certification/id/${questionnaireId}` // edit
      : `${env.kataApiUrl}/api/certification/submit`; // create

    const method = questionnaireId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Submission failed");
    }

    return await response.json();
  };

  const handleDone = async () => {
    try {
      if (Object.keys(answers).length === 0) {
        toast.warning("Please answer at least one question before submitting");
        return;
      }

      await submitAssessment();

      toast.success(
        questionnaireId ? "updated successfully!" : "Submitted successfully!"
      );

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to submit assessment");
    }
  };

  return (
    <div
      className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 12: Facilities and Safety {questionnaireId && "(Editing)"}
        </h2>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(handleAnswerChange, answers, editable)}

          {editable && <CommonFooter
            handlePrevious={handlePrevious}
            handleCancel={() => navigate(-1)}
            handleNext={handleNext}
            handleDone={handleDone}
            questionSets={questionSets}
            currentSet={currentSet}
            cancelText="Cancel"
            doneText={
              questionnaireId ? "Update Assessment" : "Submit Assessment"
            }
          />}
        </>
      )}
    </div>
  );
};

export default AddFacilitiesSafety;
